export interface GroupedItems<T> {
  label: string;
  items: T[];
}

export const groupItemsBy = <T, K extends keyof T>(items: T[], key: K): GroupedItems<T>[] => {
  const itemsByKey: Record<string, T[]> = {};

  items.forEach((item) => {
    const groupKey = String(item[key]);

    if (!itemsByKey[groupKey]) {
      itemsByKey[groupKey] = [];
    }

    itemsByKey[groupKey].push(item);
  });

  return Object.entries(itemsByKey).map(([label, groupItems]) => ({
    label,
    items: groupItems,
  }));
};
